if (jQuery('.all-insights').length) {

    (function () {

        const loader = document.querySelector('.pagination-loader')

        let container = jQuery('.all-insights'),
            isLoading = false,
            page = parseInt(container.data('page')),
            limit = parseInt(container.data('total-pages')),
            url = container.data('pagination-url'),
            category = ''

        if (jQuery('.category-link.active').length) {
            category = jQuery('.category-link.active').data('category')
        }


        function isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)

            );
        }


        const FetchPosts = (replaceCards) => {
            if (isLoading || page === limit) {
                return
            }
            isLoading = true;

            jQuery('.pagination-loader >div').fadeIn('fast')

            page++

            console.log({page, limit, category})

            $.ajax({
                method: 'GET',
                url: url.replace('{PAGE}', page) + `?category=${category}`,
                headers: {
                    accept: 'application/json'
                },
                success(data) {
                    if (data.success) {

                        if (typeof replaceCards !== 'undefined') {
                            container.html(data.data.cards)
                        } else {
                            container.append(data.data.cards)
                        }

                        limit = data.data.totalPages
                        jQuery('.insight.hidden').removeClass('hidden').fadeIn('fast')
                        isLoading = false;
                        jQuery( document ).trigger( "parallaxRefresh");

                        if (page !== limit && isInViewport(loader)) {
                            FetchPosts()
                        }
                        jQuery( document ).trigger( "parallaxRefresh");
                    }
                    jQuery('.pagination-loader >div').fadeOut('fast')

                },
                error() {
                    jQuery('.pagination-loader >div').fadeIn('fast')
                }
            })

        }


        if (page !== limit && !isLoading && isInViewport(loader)) {
            FetchPosts()
        }

        document.addEventListener('scroll', function () {
            if (page !== limit && !isLoading && isInViewport(loader)) {
                FetchPosts()
            }

        }, {
            passive: true
        });


        const changeCategory = (button) => {

            page = 0
            limit = 1
            category = button.data('category')
            isLoading = false

            jQuery('.all-categories .category-link').not(button).removeClass('active')
            button.addClass('active')


            console.log({page, limit, category})
            container.html('')
            FetchPosts(true)


        }


        jQuery(document).on('click', '.all-categories .category-link', function (event) {
            event.preventDefault()

            if (!jQuery(this).hasClass('active')) {
                changeCategory(jQuery(this))
            }
            return false
        })


    })();


}
